import { DownloadFormWebComponent } from './component/DownloadFormWebComponent';
import { WEB_COMPONENT_QUARANTINE_DOWNLOAD_FORM } from '../../../webcomponents.constants';

export { DownloadFormWebComponent };

window.customElements.define(WEB_COMPONENT_QUARANTINE_DOWNLOAD_FORM, DownloadFormWebComponent);
